import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import { saveEntity } from '../entity/api_entity';

export function fetchEmployeeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity/employee/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchEmployeeCompleteDetails(app, params){
  const { id } = params;
  const docType = 'entity/employee';
  return common.getDoc(app, { id, docType });
}

export async function fetchEmployeeForEdit(app, params) {
  const { id, path } = params;
  const docType = DocType.ENTITY;
  const doc = await common.getDoc(app, { id, docType }, { assemble_custom_fields: true });

  return util.filterCustomFieldsByViewMode(doc, path);
}

export function deleteEmployee(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.ENTITY
  });
}

export function generatePin(app, service) {
  const configService = app.service('config');
  return configService.get('generate-pin', service.user_query);
}

export function getEmployeeService(app) {
  let service = app.svc('employee');
  // service.user_query = { query: app.get('user_info') };
  return service;
}

// export function verifyUniqueEmail(app, doc) {
//   const { _id, email } = doc;

//   return getEmployeeService(app)
//     .call('verify-unique', { email, _id }, { query: app.get('user_info') })
//     .then(response => {
//       return response;
//     })
//     .catch(err => console.error(err));
// }

export async function resetPin(app, params){
  const { id } = params;
  const entity = app.service(`entity/reset/pin/${id}`);
  const result = await entity.patch('');
  return result;
}

export async function emailPin(app, params){
  const entity = app.service('entity/pin/email');
  const result = await entity.create(params);
  return result;
}

export async function smsPin(app, data, params){
  const entity = app.service('entity/pin/sms');
  const result = await entity.create(data, params);
  return result;
}

export async function saveEmployee(app, dataToSave) {
  return saveEntity(app, dataToSave);
}
